// extracted by mini-css-extract-plugin
export default {"app":"index__app___U_vIv","iframe_app":"index__iframe_app___QlTfF"};